import { UsersRepository } from "../../../data/repositories/UsersRepository";

export const UploadUserImage = async (userId, image) => {
    return await UsersRepository.uploadUserImage(userId, image);
}